// configureStore.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import rightSideAdReducer from '../slices/rightSideAd';
import dashboardReducer from '../slices/dashboardSlice';
import indicationReducer from '../slices/indication';
import virtualClassRoomReducer from '../slices/virtualClassRoomSlice'
import JitsiMeetSlice from '../slices/JitsiMeetSlice';

const createStore = () => {
  return configureStore({
    reducer: {
      auth: authReducer,
      rightSideAd: rightSideAdReducer,
      dashboard: dashboardReducer,
      indication : indicationReducer,
      virtualClassRoom : virtualClassRoomReducer,
      JitsiMeetSlice : JitsiMeetSlice
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false
    }),
  });
};

export const store = createStore();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;